import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

const modes = [
  {
    value: 0,
    label: 'off',
  },
  {
    value: 1,
    label: 'detect',
  },
  {
    value: 2,
    label: 'respond',
  }
];

function valuetext(value) {
  return `${modes[value]['label']}`;
}

export default function DetectionModeSlider({ name, value, handleSliderChange }) {
  if (value === undefined) {
    value = 1;  // default detect mode
  }
  return (
    <Box sx={{ width: 100 }}>
      <Slider
        name={name}
        aria-label="Detection mode"
        value={value}
        onChangeCommitted={(e, v) => handleSliderChange(e, v, name)}
        getAriaValueText={valuetext}
        step={null}
        valueLabelDisplay="off"
        marks={modes}
        min={0}
        max={2}
      />
    </Box>
  );
}